import React from 'react';
import OrganizationApp from './components/OrganizationApp';

/**
 * Organization page — rendered inside AdminLayout.
 * BaseAppComponent handles locale loading and initialization internally.
 */
const OrganizationAppPage: React.FC = () => {
    return <OrganizationApp />;
};

export default OrganizationAppPage;
